import { render, staticRenderFns } from "./Hu.vue?vue&type=template&id=374a975e&"
import script from "./Hu.vue?vue&type=script&lang=js&"
export * from "./Hu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports